







import DailyCheckInSettingsForm from '@/views/DailyCheckIn/DailyCheckInSettingsForm.vue';
import DailyCheckInDisclaimer from '@/views/DailyCheckIn/DailyCheckInDisclaimer.vue';

export default {
  name: 'DailyCheckInView',
  components: {
    DailyCheckInSettingsForm,
    DailyCheckInDisclaimer
  }
};
